import { useEffect } from "react";

export function useAutoScroll(element: HTMLDivElement | null, _data: unknown) {
  useEffect(() => {
    const scrollToBottom = () => {
      if (element) {
        // Scroll after a short delay to ensure content is rendered
        setTimeout(() => {
          element.scrollTo({
            top: element.scrollHeight,
            behavior: "smooth",
          });
        }, 100);
      }
    };

    scrollToBottom();
  }, [element]);
}
